import ApiService from '@common/lib/api/api.service';
import { stringify } from 'query-string';

export const getBenefitListByArea = params => {
  return ApiService.query(`keyword/benefit/list?${stringify(params)}`);
};

export const getSectionList = params => {
  return ApiService.query(`keyword/section/?${stringify(params)}`);
};

export const addSection = params => {
  return ApiService.multiPost(`keyword/section/`, params);
};

export const modifySection = params => {
  return ApiService.put(`keyword/section/{${params.id}}`, params);
};

export const removeSection = params => {
  return ApiService.delete(`keyword/section/${params.keywordId}`, params);
};

export const downloadKeywordSectionExcel = params => {
  return ApiService.file(`keyword/section/excel?${stringify(params)}`);
};

export const getSectionListByArea = params => {
  return ApiService.query(`keyword/section/list?${stringify(params)}`);
};

export const sortSection = params => {
  return ApiService.post(`keyword/section/sort`, params);
};

export const addStoreKeyword = params => {
  return ApiService.post(`keyword/store/`, params);
};

export const removeStoreKeyword = params => {
  return ApiService.delete(`keyword/store/${params.id}`, params);
};
export const getStoreList = params => {
  return ApiService.query(`keyword/store/list?${stringify(params)}`, {
    isLoading: params.isLoading !== undefined ? params.isLoading : true,
  });
};
export const getStoreMeList = () => {
  return ApiService.query(`keyword/store/list/me`);
};
export const getKeywordStoreById = params => {
  return ApiService.query(`keyword/store/${params.id}`);
};
export const getBenefitsByKeywordId = params => {
  return ApiService.query(`keyword/${params.keywordId}/benefit`);
};
export const getStoreKeywordListByKeywordId = params => {
  const newParams = {
    orderType: params.orderType,
  };
  return ApiService.query(
    `keyword/${params.keywordId}/store/list?${stringify(newParams)}`,
  );
};
